howspace.components.pdfViewer = (() => {
    'use strict';

    let focusableElements;

    const fullScreenResizeEvent = 'resize.howspacePdfViewerFullScreen';

    const setWorker = async () => {
        await lib('pdfjs-dist', 'legacy/pdf.min.mjs');
        const libVersion = lib.getVersion('pdfjs-dist');
        pdfjsLib.GlobalWorkerOptions.workerSrc = `${real.cdnUri}/dist/vendor/pdfjs-dist/${libVersion}/legacy/pdf.worker.min.mjs`;
    }

    const getFocusableElements = () => {
        focusableElements = Array.prototype.slice.call(
            document
                .querySelector('.fullscreen-viewer-modal')
                .querySelectorAll('.control-btn')
        ).filter(e => {
            return $(e).is(':visible');
        });
    }

    const isElementFocusable = e => {
        for (let i = 0; i < focusableElements.length; i++) {
            if (e === focusableElements[i]) {
                return true;
            }
        }
        return false;
    }

    const getFirstFocusableElement = () => {
        for (let i = 0; i < focusableElements.length; i++) {
            if (!focusableElements[i].disabled &&
                $(focusableElements[i]).is(':visible')) {
                return focusableElements[i];
            }
        }
        return document.activeElement;
    }

    const getLastFocusableElement = () => {
        for (let i = focusableElements.length - 1; i >= 0; i--) {
            if (!focusableElements[i].disabled &&
                $(focusableElements[i]).is(':visible')) {
                return focusableElements[i];
            }
        }
        return document.activeElement;
    }

    const getCurrentPage = pdfViewer => {
        return pdfViewer.data('current-page');
    };

    const setCurrentPage = (pdfViewer, pageNumber) => {
        pdfViewer.dataAndAttr('current-page', pageNumber);
    };

    const getPDFSourceParameters = pdfViewer => {
        // Build pdf parameters
        const parameters = Object.create(null);
        parameters.cMapPacked = true;
        parameters.enableXfa = true;
        // Scanned PDFs store their text as JBIG2 or CCITT fax images. pdf.js decodes those through separate
        // modules it fetches from this base URL, and drops every such image when the base is missing.
        parameters.wasmUrl = `${real.cdnUri}/dist/vendor/pdfjs-dist/${lib.getVersion('pdfjs-dist')}/wasm/`;

        // Getting the pdf document source
        if (pdfViewer.data('pdf-data') !== undefined) {
            const bytes = base64js.toByteArray(pdfViewer.data('pdf-data'));
            parameters.data = bytes;
        } else {
            parameters.url = pdfViewer.data('pdf-url');
        }

        return parameters;
    };

    const isSupportedBrowser = () => {
        return typeof URL.parse === 'function' && typeof Promise.withResolvers === 'function';
    };

    const showPdfElements = (pdfViewer, show) => {
        const pdfElements = pdfViewer.find('.pdf-elements');
        if (show) {
            pdfElements.removeClass('d-none');
        } else {
            pdfElements.addClass('d-none');
        }
    }

    const initPdfViewer = async pdfViewer => {
        pdfViewer.find('.unsupported-browser').addClass('d-none');

        // Validate if the browser has features/functions that are required to run the pdf.js
        if (!isSupportedBrowser()) {
            showPdfElements(pdfViewer, false);
            pdfViewer.find('.unsupported-browser .download-btn').removeClass('d-none');
            if(pdfViewer.data('pdf-data')) {
                pdfViewer.find('.unsupported-browser .download-btn').addClass('d-none');
            }
            pdfViewer.find('.unsupported-browser').removeClass('d-none');
            return;
        }

        showPdfElements(pdfViewer, true);

        if (!pdfViewer.data('view-type')) {
            return;
        }

        if (!pdfViewer.data('current-page')) {
            pdfViewer.dataAndAttr('current-page', 1);
        }

        // Init the component handler for the picture type
        if (!pdfViewer.data('pdf-data') && pdfViewer.data('view-type') === 'picture') {
            componentHandlerPdfPictureViewer(pdfViewer);
        }

        if (!pdfViewer.data('is-setup-on-load')) {
            return;
        }

        if (!pdfViewer.data('pdf-data') && !pdfViewer.data('pdf-url')) {
            return;
        }

        const viewType = pdfViewer.data('view-type');
        if (viewType === 'pdf') {
            await initPdfJsForTypePdf(pdfViewer);
        } else if (viewType === 'picture') {
            await initPdfJsForTypePicture(pdfViewer);
        }
    };

    /*
    * This part is for the picture type of pdf viewer
    */
    const showPage = (pdfViewer, newPageNumber, diff, readyFn) => {
        if (pdfViewer.hasClass('loading')) {
            return;
        }

        const pageCount = pdfViewer.data('page-count');
        if (newPageNumber < 1 || newPageNumber > pageCount) {
            return;
        }

        pdfViewer.addClass('loading');
        pdfViewer.find('.show-spinner').first().addClass('loading');
        const toolbar = pdfViewer.find('.annotation-toolbar');
        toolbar.find('.change-page-btn').prop('disabled', true);
        toolbar.find('.current-page').text(newPageNumber);

        const handlePageReady = () => {
            if (newPageNumber > 1) {
                toolbar.find('.change-page-btn[data-diff="-1"]').prop('disabled', false);
            }

            if (newPageNumber < pageCount) {
                toolbar.find('.change-page-btn[data-diff="1"]').prop('disabled', false);
            }

            if (diff) {
                if (toolbar.find('.change-page-btn[data-diff="' + diff + '"]').prop('disabled')) {
                    toolbar.find('.change-page-btn[data-diff="' + -diff + '"]').trigger('focus');
                } else {
                    toolbar.find('.change-page-btn[data-diff="' + diff + '"]').trigger('focus');
                }
            }

            if (newPageNumber == pageCount) {
                toolbar.find('.change-page-btn[data-diff="1"]').prop('disabled', true);
            }

            if (newPageNumber == 1) {
                toolbar.find('.change-page-btn[data-diff="-1"]').prop('disabled', true);
            }

            pdfViewer.removeClass('loading');
            pdfViewer.find('.show-spinner').first().removeClass('loading');

            updateViewerDataAndTriggerPageView(pdfViewer, newPageNumber);

            if (readyFn) {
                readyFn();
            }
        };

        howspace.dispatchEvent(pdfViewer, howspace.components.pdfViewer.PAGE_LOADING, {
            page: newPageNumber
        });

        setCurrentPage(pdfViewer, newPageNumber);

        if (!pdfViewer.hasClass('howspace-pdf-viewer-initialized')) {

            initPdfJsForTypePicture(pdfViewer, handlePageReady);
            return;
        }

        renderPdfPageForTypePicture(pdfViewer, handlePageReady);
    };

    const componentHandlerPdfPictureViewer = pdfViewer => {
        if (pdfViewer.hasClass('howspace-pdf-picture-viewer-initialized')) {
            return;
        }

        pdfViewer.addClass('howspace-pdf-picture-viewer-initialized');

        if (pdfViewer.data('view-type') !== 'picture') {
            return;
        }

        pdfViewer.on('click', '.change-page-btn', e => {
            const btn = $(e.currentTarget);
            const diff = btn.data('diff');
            const newPageNumber = getCurrentPage(pdfViewer) + diff;

            showPage(pdfViewer, newPageNumber, diff);
        });

        pdfViewer.on('keydown', e => {
            const pageNumber = howspace.components.pdfViewer.getCurrentPage(pdfViewer);

            if (e.keyCode === 32 || e.keyCode === 39 || e.keyCode === 40) {
                // Go to next page if user hits space, right or down
                showPage(pdfViewer, pageNumber + 1, 1);
                return false;
            }

            if (e.keyCode === 37 || e.keyCode === 38) {
                // Go to previous page if user hits left or up
                showPage(pdfViewer, pageNumber - 1, -1);
                return false;
            }
        });

        pdfViewer.on('click', '.download-btn', e => {
            howspace.dispatchEvent(pdfViewer, howspace.components.pdfViewer.DOCUMENT_DOWNLOADED, {
                evt: e
            });
        });
    };

    const initPdfJsForTypePicture = async (pdfViewer, readyFn) => {
        if (!pdfViewer.data('is-inline-pdf-data') && !pdfViewer.data('has-optimized-version')) {
            pdfViewer.addClass('loading-optimized-version');
            return;
        }

        if (pdfViewer.hasClass('howspace-pdf-viewer-initialized')) {
            return;
        }

        pdfViewer.addClass('howspace-pdf-viewer-initialized');

        await setWorker();

        // PDF.js draws every page into a canvas, so the page image is no longer needed.
        const page = pdfViewer.find('.pdf-page');
        const picture = page.children('.howspace-picture');
        if (picture.length > 0) {
            const imageWrapper = picture.find('.pdf-picture-page');
            const canvas = $('<canvas class="howspace-pdf-viewer-page-canvas"></canvas>').attr({
                width: imageWrapper.width(),
                height: imageWrapper.height()
            });
            howspace.components.picture.destroy(picture);
            picture.replaceWith(canvas);
        }

        await renderPdfPageForTypePicture(pdfViewer, readyFn);
    };

    const renderPdfPageForTypePicture = async (pdfViewer, readyFn) => {
        const parameters = getPDFSourceParameters(pdfViewer);
        // Loading document.
        await lib('pdfjs-dist', 'legacy/pdf.min.mjs');
        const loadingTask = pdfjsLib.getDocument(parameters);
        const pageNumber = getCurrentPage(pdfViewer);
        loadingTask.promise.then(document => {
            document.getPage(pageNumber).then(page => {
                const canvas = pdfViewer.find('.pdf-page .howspace-pdf-viewer-page-canvas')[0];
                if (!canvas) {
                    return;
                }
                const context = canvas.getContext('2d');

                const devicePixelRatio = window.devicePixelRatio || 1;
                const backingStoreRatio = context.webkitBackingStorePixelRatio ||
                    context.mozBackingStorePixelRatio ||
                    context.msBackingStorePixelRatio ||
                    context.oBackingStorePixelRatio ||
                    context.backingStorePixelRatio || 1;

                const pixelRatio = devicePixelRatio / backingStoreRatio;

                let viewport = page.getViewport({
                    scale: 1
                });

                // Calculate scale so that width fits the viewer
                const scale = pdfViewer.find('.pdf-page').width() / viewport.width;

                viewport = page.getViewport({
                    scale: scale * pixelRatio
                });

                canvas.height = viewport.height;
                canvas.width = viewport.width;
                canvas.style.height = canvas.height / pixelRatio + 'px';
                canvas.style.width = canvas.width / pixelRatio + 'px';

                // Render PDF page into canvas context
                const renderContext = {
                    canvasContext: context,
                    viewport: viewport
                };

                const renderTask = page.render(renderContext);

                // Wait for rendering to finish before executing pageReadyFn
                renderTask.promise.then(() => {
                    if (readyFn) {
                        readyFn();
                    }
                });
            });
        });
    };

    const presentationModeState = {
        'UNKNOWN': 0,
        'NORMAL': 1,
        'CHANGING': 2,
        'FULLSCREEN': 3
    };

    const scrollMode = {
        'UNKNOWN': -1,
        'VERTICAL': 0,
        'HORIZONTAL': 1,
        'WRAPPED': 2,
        'PAGE': 3
    };

    const scaleContainer = {
        'PAGE_AUTO': 'auto',
        'PAGE_ACTUAL': 'page-actual',
        'PAGE_FIT': 'page-fit',
        'PAGE_WIDTH': 'page-width',
        'PERCENT_50': '0.5',
        'PERCENT_75': '0.75',
        'PERCENT_100': '1',
        'PERCENT_125': '1.25',
        'PERCENT_150': '1.50',
        'PERCENT_200': '2',
        'PERCENT_300': '3',
        'PERCENT_400': '4',
    };

    const initPdfJsForTypePdf = async pdfViewer => {
        if (!pdfViewer.data('is-inline-pdf-data') && !pdfViewer.data('has-optimized-version')) {
            pdfViewer.addClass('loading-optimized-version');
            return;
        }

        if (pdfViewer.hasClass('howspace-pdf-viewer-initialized')) {
            return;
        }

        const container = pdfViewer.get(0);
        if (!container) {
            return;
        }

        pdfViewer.addClass('howspace-pdf-viewer-initialized');

        await setWorker();
        await Promise.all([
            lib('pdfjs-dist', 'legacy/pdf_viewer.mjs'),
            lib('pdfjs-dist', 'legacy/pdf_viewer.css'),
        ]);

        // Initialize Viewer Components
        const eventBus = new pdfjsViewer.EventBus();

        // (Optionally) enable hyperlinks within PDF files.
        const pdfLinkService = new pdfjsViewer.PDFLinkService({
            eventBus,
            externalLinkTarget: true,
            externalLinkRel: true
        });

        // (Optionally) enable find controller.
        const pdfFindController = new pdfjsViewer.PDFFindController({
            eventBus,
            linkService: pdfLinkService,
        });

        const pageViewer = new pdfjsViewer.PDFViewer({
            container,
            eventBus,
            linkService: pdfLinkService,
            findController: pdfFindController,
        });

        pdfLinkService.setViewer(pageViewer);

        const parameters = getPDFSourceParameters(pdfViewer);

        // Loading document.
        const loadingTask = pdfjsLib.getDocument(parameters);

        // Loading pages progress
        loadingTask.onProgress = ({ loaded, total }) => {
            pdfJsLoadingProgress(loaded / total);
        };

        loadingTask.promise.then(document => {
            // Document loaded, specifying document for the viewer and the (optional) linkService.
            pageViewer.setDocument(document);
            pdfLinkService.setDocument(document, null);

            // Describe function will be executed on page initial
            eventBus.on("pagesinit", () => {
                // We can use pageViewer now, e.g. let's change default scale.
                pageViewer.currentScaleValue = scaleContainer.PAGE_AUTO;
                if (pdfViewer.data('mode') === 'presentation') {
                    // Set to the default scale and presentation mode before going to fullscreen
                    pageViewer.presentationModeState = presentationModeState.FULLSCREEN;
                    pageViewer.currentScaleValue = scaleContainer.PAGE_FIT;
                    pageViewer.scrollMode = scrollMode.PAGE;
                }

                // pdfViewer on widget
                const pdfViewerOnWidget = $('.howspace-pdf-viewer[data-uploadedfile-id="' + pdfViewer.data('uploadedfile-id') + '"][data-view-type="picture"]');
                if (pdfViewerOnWidget.length > 0 && getCurrentPage(pdfViewerOnWidget) > 1) {
                    pdfLinkService.goToPage(getCurrentPage(pdfViewerOnWidget));
                }

                $('.fullscreen-viewer-modal .pdf-toolbar .total-pages').text(document.numPages);

                pdfJsEnableNavigationButtons(pdfViewer);
            });

            // Handle resize browser window
            eventBus.on("resize", () => {
                if (!document || !pageViewer) {
                    return;
                }
                const currentScaleValue = pageViewer.currentScaleValue;
                if (currentScaleValue === "auto" || currentScaleValue === "page-fit" || currentScaleValue === "page-width") {
                    pageViewer.currentScaleValue = currentScaleValue;
                }
                pageViewer.update();
            });

            // Add some additional properties to the pdfViewer
            pdfViewer.data('pdf-doc', document);
            pdfViewer.data('pdf-page-viewer', pageViewer);
            pdfViewer.data('pdf-link-service', pdfLinkService);
            pdfViewer.data('pdf-event-bus', eventBus);

            pdfJsViewerComponentHandler(pdfViewer);
        });
    };

    const pdfJsLoadingProgress = level => {
        // TODO: Implement loading progress bar according when fullscreen mode has been implemented
    };

    const fullScreenKeyDownHandler = (e, pdfViewer) => {
        if (e.keyCode === 32 || e.keyCode === 39 || e.keyCode === 40) {
            // Go to next page if user hits space, right or down
            const newPageNumber = getCurrentPage(pdfViewer) + 1;
            pdfJsShowPage(pdfViewer, newPageNumber);
            return false;
        }

        if (e.keyCode === 37 || e.keyCode === 38) {
            // Go to previous page if user hits left or up
            const newPageNumber = getCurrentPage(pdfViewer) - 1;
            pdfJsShowPage(pdfViewer, newPageNumber);
            return false;
        }

        if (focusableElements && e.keyCode === 9) {
            if (!isElementFocusable(document.activeElement)) {
                e.preventDefault();
                if (e.shiftKey) {
                    getLastFocusableElement().focus();
                } else {
                    getFirstFocusableElement().focus();
                }
            } else {
                if (e.shiftKey) {
                    if (document.activeElement === getFirstFocusableElement()) {
                        e.preventDefault();
                        getLastFocusableElement().focus();
                    }
                } else {
                    if (document.activeElement === getLastFocusableElement()) {
                        e.preventDefault();
                        getFirstFocusableElement().focus();
                    }
                }
            }
        }
    };

    const pdfJsViewerComponentHandler = pdfViewer => {
        $('.fullscreen-viewer-modal .change-page-btn').on('click', e => {
            const btn = $(e.currentTarget);
            const diff = btn.data('diff');
            const newPageNumber = getCurrentPage(pdfViewer) + diff;
            pdfJsShowPage(pdfViewer, newPageNumber);
        });

        pdfViewer.closest('.fullscreen-viewer-modal').on('keydown', e => {
            fullScreenKeyDownHandler(e, pdfViewer);
        });

        $('.fullscreen-viewer-modal .zoom-btn').on('click', e => {
            const btn = $(e.currentTarget);

            btn.dataAndAttr('zoomed', btn.data('zoomed') === 'in' ? 'out' : 'in');

            const pageViewer = pdfViewer.data('pdf-page-viewer');
            if (!pageViewer) {
                return;
            }

            if (btn.data('zoomed') === 'in') {
                pageViewer.currentScaleValue = scaleContainer.PAGE_WIDTH;
                btn.find('.btn-text').text(howspace.translate('common_zoom_out'));
            } else {
                pageViewer.currentScaleValue = scaleContainer.PAGE_AUTO;
                btn.find('.btn-text').text(howspace.translate('common_zoom_in'));
            }
            pageViewer.update();
        });

        $('.fullscreen-viewer-modal .presentation-mode-btn').on('click', e => {
            startPresentationMode(pdfViewer);
        });

        $('.fullscreen-viewer-modal .end-presentation-mode-btn').on('click', e => {
            endPresentationMode(pdfViewer);
        });

        real.dom.$window.off(fullScreenResizeEvent).on(fullScreenResizeEvent, () => {
            pdfJsWindowResizedHandler(pdfViewer);
        });

        pdfViewer.on('scroll', () => {
            pdfJsScroll(pdfViewer);
        });

        $('.fullscreen-viewer-modal').on(howspace.components.modal.MODAL_CLOSING, () => {
            focusableElements = null;
            real.dom.$window.off(fullScreenResizeEvent);

            const viewerOnPdfWidget = $('.widget-pdf:not(.synced) .howspace-pdf-viewer[data-uploadedfile-id="' + pdfViewer.data('uploadedfile-id') + '"][data-view-type="picture"]');
            if (viewerOnPdfWidget.length > 0) {
                showPage(viewerOnPdfWidget, pdfViewer.data('pdf-page-viewer').currentPageNumber, null);
            }
        });

        $('.fullscreen-viewer-modal .download-btn').on('click', e => {
            const viewerOnPdfWidget = $('.widget-pdf .howspace-pdf-viewer[data-uploadedfile-id="' + pdfViewer.data('uploadedfile-id') + '"][data-view-type="picture"]');
            if (viewerOnPdfWidget.length === 0) {
                return;
            }

            howspace.dispatchEvent(viewerOnPdfWidget, howspace.components.pdfViewer.DOCUMENT_DOWNLOADED, {
                evt: e
            });
        });
    };

    const pdfJsShowPage = (pdfViewer, newPageNumber) => {
        const pdfDocument = pdfViewer.data('pdf-doc');
        if (!pdfDocument) {
            return;
        }
        const pdfLinkService = pdfViewer.data('pdf-link-service');
        if (!pdfLinkService) {
            return;
        }
        const pdfPageViewer = pdfViewer.data('pdf-page-viewer');
        if (!pdfPageViewer) {
            return;
        }

        if (newPageNumber < 1 || newPageNumber > pdfDocument.numPages) {
            return;
        }

        pdfLinkService.goToPage(newPageNumber);

        updateViewerDataAndTriggerPageView(pdfViewer, newPageNumber);
        pdfJsEnableNavigationButtons(pdfViewer);

        // Sync the page number to the widget if it's available
        const pdfViewerOnWidget = $('.widget-pdf:not(.synced) .howspace-pdf-viewer[data-uploadedfile-id="' + pdfViewer.data('uploadedfile-id') + '"][data-view-type="picture"]');
        if (pdfViewerOnWidget.length > 0) {
            showPage(pdfViewerOnWidget, newPageNumber, null);
        }
    };

    const pdfJsWindowResizedHandler = pdfViewer => {
        const eventBus = pdfViewer.data('pdf-event-bus');
        if (!eventBus) {
            return;
        }
        eventBus.dispatch("resize");
    };

    const pdfJsScroll = pdfViewer => {
        const pdfDocument = pdfViewer.data('pdf-doc');
        if (!pdfDocument) {
            return;
        }
        const pageViewer = pdfViewer.data('pdf-page-viewer');
        if (!pageViewer) {
            return;
        }
        // Only sync the page number to pdfViewer in the widget if the page number is different
        // since the scroll event is triggered multiple times when scrolling but the page number is not changed yet
        const pdfViewerOnWidget = $('.widget-pdf:not(.synced) .howspace-pdf-viewer[data-uploadedfile-id="' + pdfViewer.data('uploadedfile-id') + '"][data-view-type="picture"]');
        if (pdfViewerOnWidget.length > 0 && pageViewer.currentPageNumber !== getCurrentPage(pdfViewer)) {
            showPage(pdfViewerOnWidget, pageViewer.currentPageNumber, null);
        }

        updateViewerDataAndTriggerPageView(pdfViewer, pageViewer.currentPageNumber);
        pdfJsEnableNavigationButtons(pdfViewer);
    };

    const pdfJsEnableNavigationButtons = pdfViewer => {
        const pdfDocument = pdfViewer.data('pdf-doc');
        if (!pdfDocument) {
            return;
        }

        const pageViewer = pdfViewer.data('pdf-page-viewer');
        if (!pageViewer) {
            return;
        }

        const currentPage = pageViewer.currentPageNumber;
        const toolbar = $('.fullscreen-viewer-modal .pdf-toolbar');
        toolbar.find('.change-page-btn').prop('disabled', false);
        if (currentPage <= 1) {
            toolbar.find('.change-page-btn[data-diff="-1"]').prop('disabled', true);
        }
        if (currentPage >= pdfDocument.numPages) {
            toolbar.find('.change-page-btn[data-diff="1"]').prop('disabled', true);
        }

        toolbar.find('.current-page').text(currentPage);
    };

    const updateViewerDataAndTriggerPageView = (pdfViewer, pageNumber) => {
        setCurrentPage(pdfViewer, pageNumber);

        howspace.dispatchEvent(pdfViewer, howspace.components.pdfViewer.PAGE_READY, {
            page: pageNumber
        });
    };

    const startPresentationMode = pdfViewer => {
        const pageViewer = pdfViewer.data('pdf-page-viewer');
        if (!pageViewer) {
            return;
        }

        const pdfLinkService = pdfViewer.data('pdf-link-service');
        if (!pdfLinkService) {
            return;
        }

        const requestFullScreenElement = pdfViewer.closest('.modal-body');
        if (!requestFullScreenElement) {
            return;
        }

        requestFullScreenElement.on(howspace.fullscreen.FULLSCREEN_OPENED, () => {
            $('.fullscreen-viewer-modal').trigger('focus');
            pdfViewer.closest('.fullscreen-viewer-modal').find('.modal-header .pdf-toolbar').addClass('d-none');
            requestFullScreenElement.find('.pdf-toolbar-wrapper').removeClass('d-none');
            getFocusableElements();
            pdfViewer.dataAndAttr('mode', 'presentation');
            pageViewer.currentScaleValue = scaleContainer.PAGE_FIT;
            pageViewer.scrollMode = scrollMode.PAGE;
            pageViewer.presentationModeState = presentationModeState.FULLSCREEN;
            pdfLinkService.goToPage(pageViewer.currentPageNumber);
            pageViewer.update();
        });

        requestFullScreenElement.on(howspace.fullscreen.FULLSCREEN_CLOSED, () => {
            setPdfScaleToNormal(pdfViewer);
            $('.fullscreen-viewer-modal .end-presentation-mode-btn:visible').trigger('click');
        });

        howspace.fullscreen.toggle(requestFullScreenElement);
    };

    const setPdfScaleToNormal = pdfViewer => {
        const pageViewer = pdfViewer.data('pdf-page-viewer');
        if (!pageViewer) {
            return;
        }

        pdfViewer.closest('.fullscreen-viewer-modal').find('.modal-header .pdf-toolbar').removeClass('d-none');

        pageViewer.currentScaleValue = scaleContainer.PAGE_AUTO;
        pageViewer.scrollMode = scrollMode.VERTICAL;
        pageViewer.presentationModeState = presentationModeState.NORMAL;
        pageViewer.update();
    }

    const endPresentationMode = pdfViewer => {
        pdfViewer.removeData('mode');

        const pageViewer = pdfViewer.data('pdf-page-viewer');
        if (!pageViewer) {
            return;
        }

        const requestFullScreenElement = pdfViewer.closest('.modal-body');
        if (!requestFullScreenElement) {
            return;
        }

        requestFullScreenElement.find('.pdf-toolbar-wrapper').addClass('d-none');

        if (requestFullScreenElement.hasClass('fullscreen')) {
            howspace.fullscreen.toggle(requestFullScreenElement);
        }
    };

    real.onTierReady(real.TIER_2, () => {
        real.events.on('uploadedfile:pdf:optimized', (notification) => {
            const pdfViewer = $('.howspace-pdf-viewer[data-uploadedfile-id="' + notification.object.uploadedfile.id + '"][data-has-optimized-version="false"]');
            if (pdfViewer.length === 0) {
                return;
            }

            pdfViewer.dataAndAttr('has-optimized-version', true);
            pdfViewer.removeClass('loading-optimized-version');

            // Reinitialize the pdf viewer
            initPdfViewer(pdfViewer);
        });
    });

    real.dom.$body.on('click', '.howspace-pdf-viewer[data-allow-fullscreen="true"] .pdf-picture', e => {
        const target = $(e.target);
        const pdfViewer = target.closest('.howspace-pdf-viewer');

        if (target.closest('.annotation-pin').length > 0) {
            return;
        }

        if (pdfViewer.closest('.is-pinning').length > 0 || pdfViewer.closest('.is-annotating').length > 0) {
            return;
        }

        if (!pdfViewer.data('uploadedfile-id')) {
            return;
        }

        const fileId = pdfViewer.data('uploadedfile-id');
        const viewUrl = encodeURIComponent(pdfViewer.data('view-url') ?? '');
        const downloadUrl = encodeURIComponent(pdfViewer.data('download-url') ?? '');
        const url = real.baseUri + '/utils/fullscreen-viewer-modal?type=pdf&uploaded_file_id=' + fileId + '&view_url=' + viewUrl + '&download_url=' + downloadUrl;
        howspace.components.modal.show(url, null, {fullScreen: true});
    });

    document.body.addEventListener('keydown', e => {
        if (
            e.key === 'Enter' &&
            document.activeElement &&
            document.activeElement.classList.contains('howspace-pdf-viewer') &&
            document.activeElement.dataset.allowFullscreen === 'true'
        ) {
            document.activeElement.querySelector('.pdf-elements')?.click();
        }
    });

    return {
        PAGE_LOADING: 'howspace-pdf-viewer-page-loading',
        PAGE_READY: 'howspace-pdf-viewer-page-ready',
        PAGE_VIEWED: 'howspace-pdf-viewer-page-viewed',
        DOCUMENT_DOWNLOADED: 'howspace-pdf-viewer-document-downloaded',
        init: (elem) => {
            elem.findIncludingSelf('.howspace-pdf-viewer:not(.howspace-pdf-viewer-initialized)').each(async function () {
                const pdfViewer = $(this);
                await initPdfViewer(pdfViewer);
            });
        },
        destroy: (elem) => {
            elem.findIncludingSelf('.howspace-pdf-viewer.howspace-pdf-viewer-initialized').each(function () {
                const pdfViewer = $(this);
                pdfViewer.removeClass('howspace-pdf-viewer-initialized howspace-pdf-picture-viewer-initialized');
            });
        },
        showPage: showPage,
        pdfJsShowPage: pdfJsShowPage,
        getCurrentPage: getCurrentPage,
        setData: async (pdfViewer, data) => {
            pdfViewer.data('pdf-data', data);
            pdfViewer.dataAndAttr('is-inline-pdf-data', true);
            await initPdfViewer(pdfViewer);
        }
    };
})();
